import { WORDPRESS_ACTIVE_SESSION_COOKIE } from '@/lib/middleware/wordpress';
import { useEffect, useState } from 'react';

export const useHasWPSession = () => {
  const [hasWPSession, setHasWPSession] = useState(false);
  useEffect(() => {
    const wpCookieValue = document.cookie
      .split('; ')
      .find(row => row.startsWith(`${WORDPRESS_ACTIVE_SESSION_COOKIE}=`))
      ?.split('=')[1];
    if (wpCookieValue === '1') {
      setHasWPSession(true);
    }
  }, []);
  return { hasWPSession };
};
